import isObject from 'lodash/isObject';

export function enhanceErrorWithMessage(error: unknown, message: string) {
  if (isObject(error)) {
    (error as unknown as { errorMessage: string }).errorMessage = message;
  }
}
